import React, { PureComponent } from 'react';
import { TimePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { API, FAST_ANIMATION } from '../../../ws/constants';

var moment = require('moment');

class BreakModalBox extends PureComponent {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            staffId:this.props.staffId
            , isVisible:false
            , loading:true
            , editLunch:1
            , editDinner:0
            , breakDate:moment(this.props.breakDate)
            , lunchBreakStart:"13:00"
            , lunchBreakEnd:"14:00"
            , dinnerBreakStart:""
            , dinnerBreakEnd:""
            , notes:""
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount(){
        setTimeout(() => {
            this.setState({isVisible:true});
        }, FAST_ANIMATION);
        fetch(API + "getbreaks&getbystaffid="+this.props.staffId+"&bydate="+this.props.breakDate)
        .then(response => response.json())
        .then(result => {
            this.setState({
            editLunch:result.data[0].LunchBreakStart !== null ? 1 : 0
            , editDinner:result.data[0].DinnerBreakStart !== null ? 1 : 0
            , breakDate:moment(this.props.breakDate)
            , lunchBreakStart:result.data[0].LunchBreakStart !== null ? moment(this.props.breakDate + " " + result.data[0].LunchBreakStart) : null
            , lunchBreakEnd:result.data[0].LunchBreakEnd !== null ? moment(this.props.breakDate + " " + result.data[0].LunchBreakEnd) : null
            , dinnerBreakStart:result.data[0].DinnerBreakStart !== null ? moment(this.props.breakDate + " " + result.data[0].DinnerBreakStart) : null
            , dinnerBreakEnd:result.data[0].DinnerBreakEnd !== null ? moment(this.props.breakDate + " " + result.data[0].DinnerBreakEnd) : null
            , notes:result.data[0].Notes !== null ? result.data[0].Notes : ""
            , loading: false
        })});
    }

    /* END React own Functions */

    /* START Handles */

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value });
    handleLunchStartChange = (value) => this.setState({ lunchBreakStart: value });
    handleLunchEndChange = (value) => this.setState({ lunchBreakEnd: value });
    handleDinnerStartChange = (value) => this.setState({ dinnerBreakStart: value });
    handleDinnerEndChange = (value) => this.setState({ dinnerBreakEnd: value });

    handleOk = (e) => {
        let DEFAULT_QUERY = "savebreak&staffid=" + this.state.staffId + "&breakdate=" + moment(this.state.breakDate).format('YYYY-MM-DD')
                            + "&lunchbreakstart=" + (this.state.editLunch && this.state.lunchBreakStart !== ""  ? moment(this.state.lunchBreakStart).format('HH:mm:00') : null)
                            + "&lunchbreakend=" + (this.state.editLunch && this.state.lunchBreakEnd !== "" ? moment(this.state.lunchBreakEnd).format('HH:mm:00')  : null)
                            + "&dinnerbreakstart=" + (this.state.editDinner && this.state.dinnerBreakStart !== "" ? moment(this.state.dinnerBreakStart).format('HH:mm:00')  : null)
                            + "&dinnerbreakend=" + (this.state.editDinner && this.state.dinnerBreakEnd !== "" ? moment(this.state.dinnerBreakEnd).format('HH:mm:00')  : null)
                            + "&notes=" + this.state.notes.trim() + "&cur_userid="+this.props.loginData.Id + "&cur_username="+this.props.loginData.Name;

        this.setState({loading:true});

        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(result => {
            this.setState({loading:false,isVisible:false});
            setTimeout(() => {
                this.props.modalCallBack(result, false);
            }, FAST_ANIMATION);
        });
    }

    handleCancel = (e) => {
        this.setState({loading:false,isVisible:false});
        setTimeout(() => {
            this.props.modalCallBack(false, false); // 1st param should be the result whilst the second should be (keepModalOpen)
        }, FAST_ANIMATION);
    }

    /* END Handles */

    /* START Component Functions */

    /* END Component Functions */

    /* START Renders */

    render() {
        const { editable } = this.props;
        const activeClass = this.state.isVisible ? "active" : ""
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div className="form">
                <div className={"modalBox addEditPage " + activeClass + loadingClass}>
                    <button type="button" className="simpleBtn closeModal" onClick={this.handleCancel}><i className="fa fa-times"></i></button>
                    <div className="row">
                        <div className="col-12"><h2>Almoço
                            <span className="float-right">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="editLunch"
                                            checked={!!+this.state.editLunch}
                                            disabled={!editable}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                    }
                                    label="Sim"/>
                            </span></h2>
                        </div>
                        <div className="col-6">
                            <div className="fieldHolder">
                                <TimePicker
                                    fullWidth
                                    id={"lunchBreakStart"}
                                    name={"lunchBreakStart"}
                                    value={this.state.lunchBreakStart}
                                    onChange={this.handleLunchStartChange}
                                    ampm={false}
                                    format="HH:mm"
                                    placeholder="Início do almoço"
                                    label="Início do almoço"
                                    disabled={!editable || !this.state.editLunch}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                />
                                {/* <TextField
                                    fullWidth={true}
                                    id={"lunchBreakStart"}
                                    name={"lunchBreakStart"}
                                    type="time"
                                    value={this.state.lunchBreakStart}
                                    onChange={this.handleFieldChange}
                                    placeholder="Início do almoço"
                                    label="Início do almoço"
                                    disabled={!editable || !this.state.editLunch}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                /> */}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="fieldHolder">
                                <TimePicker
                                    fullWidth
                                    id={"lunchBreakEnd"}
                                    name={"lunchBreakEnd"}
                                    value={this.state.lunchBreakEnd}
                                    onChange={this.handleLunchEndChange}
                                    ampm={false}
                                    format="HH:mm"
                                    placeholder="Fim do Almoço"
                                    label="Fim do almoço"
                                    disabled={!editable || !this.state.editLunch}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                />
                                {/* <TextField
                                    fullWidth={true}
                                    id={"lunchBreakEnd"}
                                    name={"lunchBreakEnd"}
                                    type="time"
                                    value={this.state.lunchBreakEnd}
                                    onChange={this.handleFieldChange}
                                    placeholder="Fim do Almoço"
                                    label="Fim do almoço"
                                    disabled={!editable || !this.state.editLunch}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                /> */}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12"><h2>Jantar
                            <span className="float-right">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="editDinner"
                                            checked={!!+this.state.editDinner}
                                            disabled={!editable}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                    }
                                    label="Sim"/>
                            </span></h2>
                        </div>
                        <div className="col-6">
                            <div className="fieldHolder">
                                <TimePicker
                                    fullWidth
                                    id={"dinnerBreakStart"}
                                    name={"dinnerBreakStart"}
                                    value={this.state.dinnerBreakStart}
                                    onChange={this.handleDinnerStartChange}
                                    placeholder="Início do jantar"
                                    label="Início do jantar"
                                    disabled={!editable || !this.state.editDinner}
                                    ampm={false}
                                    format="HH:mm"
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                />
                                {/* <TextField
                                    fullWidth={true}
                                    id={"dinnerBreakStart"}
                                    name={"dinnerBreakStart"}
                                    type="time"
                                    value={this.state.dinnerBreakStart}
                                    onChange={this.handleFieldChange}
                                    placeholder="Início do jantar"
                                    label="Início do jantar"
                                    disabled={!editable || !this.state.editDinner}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                /> */}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="fieldHolder">
                                <TimePicker
                                    fullWidth
                                    id={"dinnerBreakEnd"}
                                    name={"dinnerBreakEnd"}
                                    value={this.state.dinnerBreakEnd}
                                    onChange={this.handleDinnerEndChange}
                                    placeholder="Fim do jantar"
                                    label="Fim do jantar"
                                    disabled={!editable || !this.state.editDinner}
                                    ampm={false}
                                    format="HH:mm"
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                />
                                {/* <TextField
                                    fullWidth={true}
                                    id={"dinnerBreakEnd"}
                                    name={"dinnerBreakEnd"}
                                    type="time"
                                    value={this.state.dinnerBreakEnd}
                                    onChange={this.handleFieldChange}
                                    placeholder="Fim do jantar"
                                    label="Fim do jantar"
                                    disabled={!editable || !this.state.editDinner}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{step: 300}}
                                /> */}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="fieldHolder">
                                <TextField fullWidth={true}
                                           id="notes"
                                           value={this.state.notes}
                                           onChange={this.handleFieldChange}
                                           disabled={!editable}
                                           multiline={true}
                                           rows={4}
                                           label="Observações" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <Button onClick={this.handleCancel} variant="contained" className="defaultButton">Cancelar</Button>
                            { editable && <Button onClick={this.handleOk} className="float-right" variant="contained" color="primary"><i className='fa fa-check'></i>Salvar</Button>}
                        </div>
                    </div>
                </div>
                <div className={"darkOverlay " + activeClass}></div>
            </div>
        );
    }
}

export default BreakModalBox;
